// import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		name: '404',
		component: () => import(/* webpackChunkName: "main" */ '@/pages/404/'),
		meta: {
			title: 'Demand Factor Dashboards'
		}
	},
	{
		path: '/:param',
		name: 'Login',
		component: () => import(/* webpackChunkName: "main" */ '@/pages/Login/'),
		meta: {
			title: 'Demand Factor Dashboards'
		}
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: () => import(/* webpackChunkName: "main" */ '@/pages/Dashboard/'),
		meta: {
			title: 'Demand Factor Dashboards'
		}
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior () {
		return { top: 0 }
	}
})

router.beforeEach((to, from, next) => {
	const title = to.meta.title
	if (title) {
		document.title = title
	}
	next()
})

export default router